module.exports = __webpack_public_path__ + "static/media/xiangyangshan_web.934e915d.webp";